import { render, staticRenderFns } from "./faturar.vue?vue&type=template&id=203f9db0&scoped=true"
import script from "./faturar.vue?vue&type=script&lang=js"
export * from "./faturar.vue?vue&type=script&lang=js"
import style0 from "./faturar.vue?vue&type=style&index=0&id=203f9db0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203f9db0",
  null
  
)

export default component.exports